import React from 'react'
import { Skeleton } from '../ui/skeleton'
function FilterSkeleton() {
  return (
    <div className='w-full bg-white p-3 rounded-lg h-96'>
      <Skeleton className='h-10 w-50 mt-10'/>
      <Skeleton className='h-10 w-50 mt-10'/>
      <Skeleton className='h-10 w-50 mt-10'/>
      <Skeleton className='h-10 w-50 mt-10'/>
    </div>
  )
}

export default FilterSkeleton